import React, { useContext, useState } from "react";
import { Wrapper } from "./style";
import { MakeApiCall } from "../../../../apis";
import { Table, Tooltip, message, Tag, Select, Breadcrumb, Empty } from "antd";
import "moment-timezone";
import { useEffect } from "react";
import {
  ClockCircleOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import Pagination from "../../../../components/pagination";
import moment from "moment";
import { TableLoading } from "../../../../components/table-animation";
import { RenderTable, numberformat } from "../../../../config";
import { GlobalContext } from "../../../../common-context";
import CredentialsError from "../../../credential-page";
import InfoVideo from "../../../../components/header-icons";
import { useHistory, useLocation } from "react-router-dom";

const CentralLog = ({ menusList, pageTitle }) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [filters, setFilters] = useState({
    event_type: null,
    event_name: null,
    event_status: null,
    marketplace_type: "amazon",
  });

  const urlParams = new URLSearchParams(location?.search);
  // const keys = [];
  // for (const key of urlParams.keys()) {
  //   keys.push({ key, value: urlParams.get(key) });
  // }

  const [marketplaceLoading, setMarketplaceLoading] = useState(true);
  const [marketplaceList, setMarketplaceList] = useState([
    {
      label: "Amazon",
      value: "amazon",
    },
    // {
    //   label: "Walmart",
    //   value: "walmart",
    // },
  ]);

  const [eventTypeList, setEventTypeList] = useState([]);

  const [eventNameList, setEventNameList] = useState([]);

  const [filterLoading, setFilterLoading] = useState(true);
  const [eventStatus, setEventStatus] = useState([]);
  const [sortFilters, setSortFilters] = useState({
    field_name: null,
    sort_by: null,
  });

  const getList = async (data) => {
    const response = await MakeApiCall(
      `user/system-event-process?page=${page}&event_type=${
        data?.event_type || ""
      }&event_name=${data?.event_name || ""}&event_status=${
        data?.event_status || ""
      }&marketplace_type=${data?.marketplace_type || ""}&field_name=${
        data?.field_name || ""
      }&sort_by=${data?.sort_by || ""}`,
      "get",
      null,
      true
    );

    if (response?.status) {
      setList(response?.data?.records);
      setPageSize(response?.data?.pagination?.page_size);
      setTotalPage(response?.data?.pagination?.totalCount);
      setLoading(false);
    } else {
      message.warning(response?.message);
      setLoading(false);
    }
  };
  const sortType = {
    descend: "desc",
    ascend: "asc",
  };
  const DefaultSortType = {
    desc: "descend",
    asc: "ascend",
  };
  const PropsFilter = (type) => ({
    defaultSortOrder:
      type === sortFilters?.field_name
        ? DefaultSortType?.[sortFilters?.sort_by]
        : [],
    sorter: () => {},
  });

  const handleChange = (_, __, sorter) => {
    const obj = {
      field_name: sortType?.[sorter?.order] ? sorter?.column?.filterIndex : "",
      sort_by: sortType?.[sorter?.order] || "",
    };

    setSortFilters(obj);
    getList({ ...obj });
  };

  const reportLogFilterAction = async (event_type) => {
    setFilterLoading(true);
    const response = await MakeApiCall(
      `log/report-log-filter?event_type=${event_type || ""}`,
      "get",
      null,
      true
    );

    if (response?.status) {
      console.log(response, "response");
      if (!event_type) {
        setEventTypeList(
          response?.data?.event_types?.map((d) => ({ label: d, value: d })) ||
            []
        );
      }
      setEventNameList(
        response?.data?.event_names?.map((d) => ({ label: d, value: d })) || []
      );
      setEventStatus(
        response?.data?.event_status?.map((d) => ({ label: d, value: d })) || []
      );

      setFilterLoading(false);
    } else {
      setEventTypeList([]);
      setEventNameList([]);
      setEventStatus([]);
      setFilterLoading(false);
      message.warning(response?.message);
    }
  };

  const getMarketplaceList = async () => {
    const response = await MakeApiCall(`sales-channel`, "get", null, true);
    if (response?.status) {
      // setMarketplaceList(response?.data?.sales_channel || []);
      setMarketplaceLoading(false);
    } else {
      setMarketplaceLoading(false);
      message.warning(response?.message);
    }
  };
  const [locationData, setLocationData] = useState({});
  const getLocationData = async (data) => {
    const response = await MakeApiCall(
      `menu-content-data?menu_item_id=14`,
      "get",
      null,
      true
    );

    if (response?.status) {
      setLocationData(response?.data);
    } else {
      message.warning(response?.message);
    }
  };

  useEffect(() => {
    getLocationData();
    reportLogFilterAction();
    return () => {};
  }, []);

  useEffect(() => {
    setMarketplaceLoading(true);
    getMarketplaceList();

    // getEventNameList();
    // setEventNameLoading(true);

    // getEventTypeList();
    // setEventTypeLoading(true);
    return () => {};
  }, []);
  const contextValue = useContext(GlobalContext);

  useEffect(() => {
    if (urlParams.get("event_status")) {
      setFilters({
        event_type: null,
        event_name: null,
        event_status: filters?.event_status || urlParams.get("event_status"),
        marketplace_type: "amazon",
      });
      getList({
        page: page,
        event_type: filters?.event_type || urlParams.get("event_type"),
        event_name: filters?.event_name || urlParams.get("event_name"),
        event_status: filters?.event_status || urlParams.get("event_status"),
        marketplace_type: "amazon",
        ...sortFilters,
      });
    }
  }, [urlParams.get("event_status")]);
  useEffect(() => {
    if (!filters?.event_status && urlParams.get("event_status")) {
      return;
    }
    getList({
      page: page,
      event_type: filters?.event_type,
      event_name: filters?.event_name,
      event_status: filters?.event_status,
      marketplace_type: "amazon",
      ...sortFilters,
    });
    return () => {};
  }, [page]);

  const onPageNo = (e) => {
    setLoading(true);
    setList([]);
    setPage(e);
  };

  const onPerPage = (e) => {
    setPage(1);
    setPageSize(e);
    setLoading(true);
  };

  const checkDateValidation = (date) => {
    if (moment(date).isValid()) {
      return date;
    }
    return false;
  };
  const columns = [
    {
      title: "ID",
      align: "center",
      width: 100,
      ellipsis: true,
      render: (_, __, i) => {
        return <span>{(page - 1) * pageSize + 1 + i}</span>;
      },
    },
    {
      title: "Queued (ET)",
      width: 280,
      filterIndex: "created_at",
      render: (item) => {
        return (
          <div>
            <span>
              {moment(new Date(item.created_at * 1000))?.format(
                "MMM DD, YYYY hh:mm A"
              )}
            </span>
          </div>
        );
      },
    },
    {
      title: "Dataset Date (PT)",
      width: 240,
      filterIndex: "event_date",
      render: (item) => {
        if (
          item?.event_type === "SP API Report" ||
          item?.event_type === "Financial API"
        ) {
          return (
            <>
              <div
                className="d-flex"
                style={
                  {
                    // justifyItems: "center",
                    // justifyContent: "start",
                    // height: "55px",
                  }
                }
              >
                <span>
                  {checkDateValidation(
                    new Date(
                      JSON.parse(item?.event_details)?.[
                        item?.event_type === "Financial API"
                          ? "start_date"
                          : "data_start_time"
                      ]
                    )
                  )
                    ? moment(
                        new Date(
                          JSON.parse(item?.event_details)?.[
                            item?.event_type === "Financial API"
                              ? "start_date"
                              : "data_start_time"
                          ]
                        )
                      ).format("MMM DD, YYYY")
                    : moment(
                        new Date(
                          JSON.parse(item?.event_details)?.[
                            item?.event_type === "Financial API"
                              ? "data_start_time"
                              : "data_start_time"
                          ]
                        )
                      ).format("MMM DD, YYYY")}
                </span>
                to
                <br />
                <span>
                  {checkDateValidation(
                    new Date(
                      JSON.parse(item?.event_details)?.[
                        item?.event_type === "Financial API"
                          ? "end_date"
                          : "data_end_time"
                      ]
                    )
                  )
                    ? moment(
                        new Date(
                          JSON.parse(item?.event_details)?.[
                            item?.event_type === "Financial API"
                              ? "end_date"
                              : "data_end_time"
                          ]
                        )
                      ).format("MMM DD, YYYY")
                    : moment(
                        new Date(
                          JSON.parse(item?.event_details)?.[
                            item?.event_type === "Financial API"
                              ? "data_end_time"
                              : "data_end_time"
                          ]
                        )
                      ).format("MMM DD, YYYY")}
                </span>
                <br />
              </div>
            </>
          );
        } else if (
          item?.event_type === "SKU Wise" ||
          item?.event_type === "Brand Wise"
        ) {
          return (
            <>
              <div
                className="d-flex"
                style={
                  {
                    // justifyItems: "center",
                    // justifyContent: "start",
                    // height: "55px",
                  }
                }
              >
                <span>
                  {moment(
                    new Date(JSON.parse(item?.event_details)?.["startDate"])
                  ).format("MMM DD, YYYY")}
                </span>
                to
                <br />
                <span>
                  {moment(
                    new Date(JSON.parse(item?.event_details)?.["endDate"])
                  ).format("MMM DD, YYYY")}
                </span>
                <br />
              </div>
            </>
          );
        } else {
          return moment(new Date(item?.event_date)).format("MMM DD, YYYY");
        }
      },
    },
    {
      title: "Dataset Name",
      width: 230,
      filterIndex: "event_name",
      render: (item) => {
        return (
          <Tooltip rule>
            <span>
              {item?.event_type === "Advertising Report" ? (
                item?.event_details ? (
                  <div className="d-flex">
                    <span>{item?.event_name || "N/A"}</span>
                    <span>
                      ({JSON.parse(item?.event_details)?.record_type || "N/A"})
                    </span>
                  </div>
                ) : (
                  "N/A" || "N/A"
                )
              ) : (
                item?.event_name || "N/A"
              )}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Dataset Type",
      width: 180,
      filterIndex: "event_type",
      render: (item) => {
        return <span>{item?.event_type || "N/A"}</span>;
      },
    },
    {
      title: "Request Status",
      width: 200,
      filterIndex: "status",
      render: (d) => {
        return (
          <Tag
            color={d.status === 0 ? "processing" : "success"}
            icon={
              (d.status === 0) === "processing" ? (
                <ClockCircleOutlined />
              ) : (
                <CheckCircleOutlined />
              )
            }
          >
            {d.status === 0 ? "Pending" : "Done"}
          </Tag>
        );
      },
    },
    {
      title: "Dataset Status",
      width: 150,
      filterIndex: "event_status",
      render: (item) => {
        return (
          <Tag
            color={
              item.event_status === "PENDING"
                ? "warning"
                : item.event_status === "IN_PROGRESS"
                ? "processing"
                : item.event_status === "DONE"
                ? "success"
                : item.event_status === "FAILED"
                ? "error"
                : item.event_status === "FATAL"
                ? "error"
                : item.event_status === "CANCELLED"
                ? "error"
                : "error"
            }
            icon={
              item.event_status === "PENDING" ? (
                <ClockCircleOutlined />
              ) : item.event_status === "IN_PROGRESS" ? (
                <SyncOutlined spin />
              ) : item.event_status === "DONE" ? (
                <CheckCircleOutlined />
              ) : item.event_status === "FAILED" ? (
                <CloseCircleOutlined />
              ) : item.event_status === "FATAL" ? (
                <CloseCircleOutlined />
              ) : item.event_status === "CANCELLED" ? (
                <CloseCircleOutlined />
              ) : (
                <CloseCircleOutlined />
              )
            }
          >
            {item.event_status || "N/A"}
          </Tag>
        );
      },
    },
    {
      title: "Updated At (ET)",
      width: 220,
      filterIndex: "updated_at",
      render: (item) => {
        return (
          <div>
            <span>
              {moment(new Date(item.updated_at * 1000))
                .tz("America/New_York")
                .format("MMM DD, YYYY hh:mm A")}
            </span>
          </div>
        );
      },
    },
    {
      title: "Priority",
      width: 120,
      filterIndex: "priority",
      render: (item) => {
        return (
          <>
            {item?.priority == 1 ? (
              <div className="d-flex align-items-center">
                <div
                  className="priorityColorDot me-2"
                  style={{ background: "#ff0000" }}
                ></div>
                High
              </div>
            ) : item?.priority == 2 ? (
              <div className="d-flex align-items-center">
                <div
                  className="priorityColorDot me-2"
                  style={{ background: "#faad14" }}
                ></div>
                Medium
              </div>
            ) : (
              <div className="d-flex align-items-center">
                <div
                  className="priorityColorDot me-2"
                  style={{ background: "#52c41a" }}
                ></div>
                Low
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Execution Time",
      width: 180,
      filterIndex: "execution_time",
      render: (item) => {
        return <span>{numberformat(item?.execution_time || "0")}</span>;
      },
    },
    {
      title: "Retry Count",
      width: 180,
      filterIndex: "retry_count",
      render: (item) => {
        return <span>{item?.retry_count || "0"}</span>;
      },
    },
    {
      title: "Marketplace",
      filterIndex: "marketplace",
      width: 200,
      render: (item) => {
        return <span>{item?.marketplace || "N/A"}</span>;
      },
    },

    {
      title: "Reason",
      width: 250,
      filterIndex: "note",
      render: (d) => {
        return (
          <Tooltip title={d?.note}>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "250px",
              }}
            >
              {d?.note || "N/A"}
            </div>
          </Tooltip>
        );
      },
    },
  ];

  const { lws, sp } = contextValue?.data?.credentialsStatus;

  if (
    (lws !== 1 || sp !== 1) &&
    menusList?.find((d) => d?.url === "central-log")?.is_restricted === 1
  ) {
    return <CredentialsError type="central-log" />;
  }

  return (
    <Wrapper
      id="kt_content_container"
      className="custom-ui container-fluid pt-5"
    >
      <>
        {/*begin::Row*/}
        <div className="row gy-5 g-xl-5">
          {/*begin::Col*/}
          <div className="col-xxl-12">
            {/*begin::Tables Widget 9*/}
            <div className="card card-xxl-stretch mb-5 mb-xl-8">
              {/*begin::Header*/}
              <div className="card-header ">
                <h3 className="card-title">
                  {pageTitle}
                  <InfoVideo
                    data={locationData}
                    title={"central_log"}
                    className={"ms-3"}
                  />
                </h3>
                <div className="card-toolbar gap-2">
                  {" "}
                  <Select
                    loading={filterLoading}
                    options={eventTypeList}
                    className="w-200px"
                    size="large"
                    allowClear
                    placeholder="Select Event Type"
                    onChange={(e) => {
                      setLoading(true);
                      setList([]);

                      setFilters({
                        ...filters,
                        event_type: e,
                        event_name: null,
                        event_status: null,
                      });
                      reportLogFilterAction(e);
                      getList({
                        page: page,
                        event_type: e,
                        event_name: null,
                        event_status: null,
                        marketplace_type: "amazon",
                        ...sortFilters,
                      });
                      // getList({
                      //   event_status:
                      //     filters?.event_status ||
                      //     urlParams.get("event_status"),
                      // });
                    }}
                    value={filters?.event_type || null}
                  />
                  <Select
                    options={eventNameList}
                    loading={filterLoading}
                    className="w-200px"
                    allowClear
                    size="large"
                    placeholder="Select Event Name"
                    onChange={(e) => {
                      setLoading(true);
                      setList([]);
                      setFilters({
                        ...filters,
                        event_name: e,
                      });
                      getList({
                        page: page,
                        event_type: filters?.event_type,
                        event_name: e,
                        event_status: filters?.event_status,
                        marketplace_type: "amazon",
                        ...sortFilters,
                      });
                      // getList({
                      //   event_status:
                      //     filters?.event_status ||
                      //     urlParams.get("event_status"),
                      // });
                    }}
                    value={filters?.event_name || null}
                  />
                  <Select
                    onChange={(e) => {
                      setLoading(true);
                      setList([]);
                      setFilters({
                        ...filters,
                        event_status: e,
                      });
                      getList({
                        page: page,
                        event_type: filters?.event_type,
                        event_status: e,
                        event_name: filters?.event_name,
                        marketplace_type: "amazon",
                        ...sortFilters,
                      });
                      // getList({
                      //   event_status: e || urlParams.get("event_status"),
                      // });
                    }}
                    value={filters?.event_status || null}
                    className="w-200px"
                    allowClear
                    loading={filterLoading}
                    options={eventStatus}
                    size="large"
                    placeholder="Select Event Status"
                  />
                </div>
              </div>
              {/*end::Header*/}
              {/*begin::Body*/}
              <div className="card-body pt-0 pb-0">
                {loading ? (
                  <TableLoading
                    id="test-table"
                    columns={[1, 2, 3, 4, 5]}
                    checkBoxVal={true}
                    actions={[1, 2]}
                  />
                ) : list?.length === 0 ? (
                  <Empty />
                ) : (
                  <div className="scroll-show">
                    <Table
                      columns={columns?.map((d) => ({
                        ...d,
                        ...(d?.filterIndex ? PropsFilter(d?.filterIndex) : ""),
                        render: (props, row, index) =>
                          RenderTable(props, row, index, d),
                      }))}
                      fixed={true}
                      sticky={{
                        offsetHeader: "0px",
                      }}
                      dataSource={list}
                      rowKey="id"
                      onChange={handleChange}
                      scroll={{ x: "max-content", y: "calc(100vh - 410px)" }}
                      loading={loading}
                      pagination={false}
                      rowClassName={(record, index) => {
                        return index % 2 === 0 ? "even-row" : "odd-row";
                      }}
                      bordered
                      size="small"
                    />
                  </div>
                )}

                <Pagination
                  loading={loading || list?.length === 0}
                  pageSize={pageSize}
                  page={page}
                  totalPage={totalPage}
                  onPerPage={onPerPage}
                  onPageNo={onPageNo}
                />
              </div>
              {/*begin::Body*/}
            </div>
            {/*end::Tables Widget 9*/}
          </div>
          {/*end::Col*/}
        </div>
        {/*end::Row*/}
      </>
    </Wrapper>
  );
};

export default CentralLog;
